import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {version} from '../package';

import Vuelidate from "vuelidate";
import TokenService from "./services/storage.service.js";
import ApiService from "./services/api.service.js";
import S3Service from "./services/S3.service.js";
import LoadScript from "vue-plugin-load-script";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import "vuetify/dist/vuetify.min.css";

import config from '@/assets/js/config/Config';
window.config = config;

import startTips from '@/assets/js/config/StartTips';
Vue.prototype.$startTips = startTips;

import VueTippy, { TippyComponent } from "vue-tippy";

// Form
import Form from "@/forms/Form.js";
Object.defineProperty(Vue.prototype, "Form", { value: Form });
window.Form = Form;

// Global Event Bus
const EventBus = new Vue();
Object.defineProperty(Vue.prototype, "$eventBus", { value: EventBus });

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

// Lodash
import lodash from "lodash";
Object.defineProperty(Vue.prototype, "_", { value: lodash });

Vue.prototype.APP_VESRION = version;
Vue.prototype.$tokenService = new TokenService();
Vue.prototype.$apiService = new ApiService(process.env.VUE_APP_API_URL);
Vue.prototype.$S3Service = new S3Service();

window.API_URL = process.env.VUE_APP_API_URL;
window.APP_URL = process.env.VUE_APP_URL;

Vue.use(LoadScript);
Vue.use(Vuelidate);

Vue.use(VueTippy, { placement: "top", arrow: true, arrowType: "sharp", animation: "fade", delay: [400, null] });
Vue.component("tippy", TippyComponent);

window.Vue = Vue;

const vm = new Vue({
	router,
	store,
	vuetify,
	render: h => h(App),
}).$mount("#app");

window.Vue = Vue;
window.vm = vm;

export { vm };
